module.exports = __webpack_public_path__ + "static/irritrol-e470ba4a078e4ccbbfd87c55c469c14a.png";